export enum EExceptionDomain {
  Ws = 'ws',
  Messages = 'messages',
  Iframe = 'iframe',
  Chat = 'chat',
  Chatbot = 'chatbot',
  AgentData = 'agentData',
  OfferData = 'offerData',
  Experiments = 'experiments',
  ReplyTemplates = 'replyTemplates',
  Demand = 'demand',
  User = 'user',
  UserSession = 'userSession',
  SubAgents = 'subAgents',
  OffersForSelection = 'offersForSelection',
  LkType = 'lkType',
  Common = 'common',
  FirstMessageSend = 'critical.firstMessageSend',
  ChatsSync = 'critical.syncChats',
  ChatsGet = 'critical.getChats',
  MessageSend = 'critical.messageSend',
}
